function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.402 15.838l1.991-9a.75.75 0 01.732-.588h8.15a.75.75 0 01.732.588l1.99 9a.75.75 0 01-.731.912H3.134a.75.75 0 01-.732-.912h0z",
  strokeWidth: "1.125"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.325 6.25V4.375c0-1.036.84-1.875 1.875-1.875h0c1.037 0 1.876.84 1.876 1.875V6.25M4.58 6.505L6.845 16.75",
  strokeWidth: "1.125"
})));